(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .directive('body', modalOpenDirective);

    var rModalOpen = /\bmodal-open\b/;

    function modalOpenDirective() {
        return { restrict: 'E', link: link, };

        function link(scope, element, attrs, ctrl) {
            var oldValue = false,
                offset,
                state;

            scope.$watch(classWatch, classWatchAction);

            function classWatch() {
                return element.prop('className');
            }

            function classWatchAction(value) {
                var newValue = rModalOpen.test(value || '');
                if (newValue !== oldValue) {
                    if (oldValue = newValue) {
                        offset = { x: window.pageXOffset, y: window.pageYOffset };
                        state = { position: element.css('position'), top: element.css('top'), overflow: element.css('overflow') };
                        element.css({ position: 'fixed', top: -offset.y + 'px', overflow: 'visible' });
                    }
                    else {
                        element.css(state);
                        window.scrollTo(offset.x, offset.y);
                    }
                }
            }
        }
    }
})();
